import { useRef } from "react";
import { formatAmount } from "../util/Helpers";
import toastMessage from "../util/toastMessage";
import InputWithFix from "./InputWithFix";


const AmountInput = ({minAmount, maxAmount, currency = "USD", ...props}) => {

    const timeout = useRef();

    const minMaxCheck = amount => {
        if (minAmount && amount < minAmount){
            return toastMessage("info", `Allowed Minimum Amount is ${formatAmount(currency, minAmount, 0)}`);
        }
        if (maxAmount && amount > maxAmount){
            return toastMessage("info", `Allowed Maximum Amount is ${formatAmount(currency, maxAmount, 0)}`);
        }
    }

    // Format Input
    const autoFormatInput = e => {
        clearTimeout(timeout.current);
        let amount = e.currentTarget?.value?.replace(/[^\d.]/g, "");
        if (amount?.slice(-1) === "." || (amount?.includes(".") && amount?.slice(-1) === "0")) return;
        if (amount === ""){
            e.currentTarget.value = "";
            return;
        }
        amount = Number(amount) ?? 0;
        if (!Number.isNaN(amount) && amount !== 0){
            e.currentTarget.value = amount?.toLocaleString(undefined, { maximumFractionDigits: 2 });
        }

        timeout.current = setTimeout(_ => minMaxCheck(amount), 2000);
    }

    return <InputWithFix
                placeholder="0.00"
                name="amount"
                pattern="^\d+(,(\d+))?(,(\d+))?(,(\d+))?(,(\d+))?(\.(\d+))?$"
                className={`form-input ${props.prefix && (props.prefix.length === 1 ? "pl-10" : " pl-14")}`}
                {...props}
                type="text"
                autoComplete="off"
                onInput={autoFormatInput}
            />

}

export default AmountInput;